import { Icon, IconProp, IconProps } from '@ff-it/ui';
import type { InvoiceDirection, InvoiceType } from './common/types';
import { ReactElement } from 'react';

type DirectionConf = Record<InvoiceType, { icon: IconProp; color: IconProps['color'] }>;

const iconTypeMap: Record<InvoiceDirection, DirectionConf> = {
  income: {
    INVOICE: {
      icon: 'file-invoice',
      color: 'success500',
    },
    CREDIT: {
      icon: 'arrow-rotate-left',
      color: 'warning500',
    },
    ADVANCE: {
      icon: 'arrow-rotate-right',
      color: 'success500',
    },
  },
  expense: {
    INVOICE: {
      icon: 'file-invoice',
      color: 'brand500',
    },
    CREDIT: {
      icon: 'arrow-rotate-left',
      color: 'warning500',
    },
    ADVANCE: {
      icon: 'arrow-rotate-right',
      color: 'brand500',
    },
  },
} as const;

export function InvoiceTypeIcon({ direction, type }: { direction: InvoiceDirection; type: InvoiceType }): ReactElement {
  const { icon, color } = iconTypeMap[direction][type];
  return <Icon icon={icon} color={color} />;
}
